import { OrderTypeFlow } from 'mobx/Localization/types'
import { getTranslatedTextByKey } from 'utils/language'
import { StyledOrderTypeButton, StyledOrderTypeImage, StyledOrderTypeTitle, StyledOrderTypeImageContainer } from './OrderTypeButton.styles'

const OrderTypeButton = ({ flow, onSelectFlow }: { flow: OrderTypeFlow; onSelectFlow: (flow: OrderTypeFlow) => void }) => {
	const orderTypeText = getTranslatedTextByKey(flow.orderTypeTranslationKey, flow.orderType)

	const onClick = () => {
		onSelectFlow(flow)
	}

	return (
		<StyledOrderTypeButton onClick={onClick}>
			<StyledOrderTypeImageContainer>
				<StyledOrderTypeImage
					asset={`/images/orderTypes/${flow.orderType}.png`}
					assetFullUrl={flow.orderTypeImageSrc}
					width="unset"
					height="unset"
				/>
			</StyledOrderTypeImageContainer>
			<StyledOrderTypeTitle variant="h1">{orderTypeText}</StyledOrderTypeTitle>
		</StyledOrderTypeButton>
	)
}

export default OrderTypeButton
